const Loading = () => (
    <div className="spinner-border m-2" role="status">
        <span className="sr-only">Loading...</span>
    </div>
);

export default Loading;
